import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import NavBar from '../../../../components/CustomNav/CustomNav.Component';

import { Container, FormContainer, FormWrapper, Row, ContentWrapper, ContentHeading, ContentBody, InputWrapper, CtaWrapper, Disclaimer, VideoWrapper } from '../../Common/Common.styles';
import withServices from '../../../../HOCs/withServices';
import { currentBaseUrl } from 'src/common/services';
import VideoPlayer from 'src/components/VideoPlayer/VideoPlayer';

interface IProps {
  history?: any,
  services?: any
}
interface IState {
  navigate: boolean,
  destination: string,
  assessmentAvailable: boolean,
  assessmentID: any,
  toDashboard: boolean,
  vimeoID: any,
  loaded: boolean
}

const vimeoVar = 'parents_assess_guide';

class ParentPreassessmentGuide extends Component<IProps, IState> {
  constructor(props) {
    super(props)

    this.state = {
      navigate: false,
      destination: '',
      assessmentAvailable: false,
      assessmentID: null,
      toDashboard: false,
      vimeoID: null,
      loaded: false
    }
    this.onLogOut = this.onLogOut.bind(this);
  }

  public async componentDidMount() {
    const { services: { isUserLoggedIn, adminAPI } } = this.props;
    if (!isUserLoggedIn) {
      this.setState({ navigate: true, destination: '/login' });
    }
    const [assessmentRes, vimeoIDRes] = await Promise.all([adminAPI.getNextAssessment(), adminAPI.fetchVimeoSystemVar(vimeoVar)]);
    if (assessmentRes.ok) {
      const assessmentInfo = assessmentRes.data;
      const vimeoID = vimeoIDRes.data.value;
      if (assessmentInfo && assessmentInfo.status === 'available') {
        this.setState({ assessmentAvailable: true, assessmentID: assessmentInfo.assessment_id, vimeoID, loaded: true });
      } else {
        this.setState({ assessmentAvailable: false, navigate: true, destination: `$${currentBaseUrl()}home`, vimeoID, loaded: true });
      }
    }
  }

  public onLogOut() {
    this.setState({ navigate: true, destination: '/login' });
  }
  public startAssessment = () => {
    // alert("Parent Assessment");
    const { assessmentAvailable, assessmentID } = this.state;
    if (assessmentAvailable) {
      this.props.history.replace(`${currentBaseUrl()}assessment/${assessmentID}`);
    } else {
      this.props.history.push(`$${currentBaseUrl()}home`);
    }
  }

  public renderVimeo = () => {
    const { vimeoID, loaded } = this.state;

    if (loaded) {
      return (
        <VideoWrapper width="100%">
          <VideoPlayer videoId={vimeoID} width="582px" />
        </VideoWrapper>
      );
    } else {
      return <div />
    }
  }

  public render() {
    if (this.state.navigate) {
      return <Redirect to={this.state.destination} />
    }
    return (
      <Container>
        <NavBar logoutParent={this.onLogOut} />
        <div
          style={{
            width: "100%",
            height: "90%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Row width="80%">
            <ContentWrapper>
              <ContentHeading color="#acff24">
                WELCOME TO PERFORMANCE LEARNING
              </ContentHeading>
              <ContentBody textAlign="center">
                <span>Meet PLOA</span> <br />
                PLOA is Performance Learning’s side-kick. An intelligent,
                intuitive set of questions designed to get to know you. When
                you answer each question, be yourself and take as much as
                time as you need.
              </ContentBody>
              <button
                className="green-button start-assess"
                onClick={this.startAssessment}
              >
                START ASSESSMENT
              </button>
            </ContentWrapper>

            <FormWrapper width="50%">{this.renderVimeo()}</FormWrapper>
          </Row>
        </div>
      </Container>
    );
  }
}

export default withServices(ParentPreassessmentGuide);



// WEBPACK FOOTER //
// ./src/pages/Onboard/Parent/PreassessmentGuide/ParentPreassessmentGuide.component.tsx